










import UnderConstruction from "@/components/UnderConstruction.vue"
import { Vue, Component } from "vue-property-decorator"

@Component({
  name: "Support",
  components: {
    "under-construction": UnderConstruction,
  },
})
export default class Support extends Vue {}
